import { PropType } from 'vue'
import { makeProps as makePropsBase } from '@/packages/vue-selection-controller/general/main'

/**
 * Vue props definition object.
 *
 * @category Functions
 * @export
 * @returns Props definition object.
 */
export function makeProps() {
  const { keyGetter, updateHandler, options } = makePropsBase()

  return {
    keyGetter,
    updateHandler,
    options,
    total: {
      type: Number as PropType<number>,
      default: 0
    },
  }
}
